// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.5 2.5C20.8807 2.5 22 3.61929 22 5C22 6.38071 20.8807 7.5 19.5 7.5C18.4751 7.5 17.5959 6.88257 17.21 6H13V9.5H15.5V14.5H13V18H17.21C17.5959 17.1174 18.4751 16.5 19.5 16.5C20.8807 16.5 22 17.6193 22 19C22 20.3807 20.8807 21.5 19.5 21.5C18.4751 21.5 17.5959 20.8826 17.21 20H6.79004C6.4041 20.8826 5.52488 21.5 4.5 21.5C3.11929 21.5 2 20.3807 2 19C2 17.6193 3.11929 16.5 4.5 16.5C5.52488 16.5 6.4041 17.1174 6.79004 18H11V14.5H8.5V9.5H11V6H6.79004C6.4041 6.88257 5.52488 7.5 4.5 7.5C3.11929 7.5 2 6.38071 2 5C2 3.61929 3.11929 2.5 4.5 2.5C5.52488 2.5 6.4041 3.11743 6.79004 4H17.21C17.5959 3.11743 18.4751 2.5 19.5 2.5Z"}}]};

const GraphvizFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'graphviz-filled',
    ref,
    icon: element,
  },
));

GraphvizFilledIcon.displayName = 'GraphvizFilledIcon';

export default GraphvizFilledIcon;
